const CONTROLS = [
  ".section-add-element",
  ".cf-draggable-creation-hover",
  ".element-spacing-wrapper",
  ".section-spacing-wrapper",
  ".section-column-spacing-wrapper",
  ".section-column-spacing-handle",
  ".fr-toolbar",
  ".fr-popup",
].join(", ");

export const canvasObjectTarget = (canvas, target) => {
  if (!target?.closest || !canvas?.contains(target)) return null;
  if (target.closest(CONTROLS)) return null;
  const node = target.closest(
    ".cf-element, .cf-section-overlay, .cf-background-overlay, .cf-section, .cf-column, .cf-flex-column[data-section-column-id], .canvas[data-step-id], .step-toggle[data-step-id]"
  );
  if (!node || !canvas.contains(node)) return null;
  if (node.matches(".cf-element")) return { type: "elements", target: node };
  if (node.matches(".cf-section, .cf-section-overlay")) {
    return { type: "sections", target: node.closest(".cf-section") };
  }
  if (node.matches(".canvas, .step-toggle")) {
    return { type: "steps", target: node.closest(".canvas[data-step-id]") };
  }
  const column = node.closest(".cf-column, .cf-flex-column");
  return column
    ? {
        type: column.matches(".cf-flex-column") ? "section_columns" : "columns",
        target: column,
      }
    : null;
};
